export default {
  props: {
    href: {
      type: String
    },
    label: {
      type: String
    },
    tag: {
      type: String,
      default: 'button'
    },
    target: {
      type: String
    }
  }
}
